import React, { Component } from "react";
import { Button, Spinner, Form } from "react-bootstrap";
import axios from "axios";
import profileimage from "../assets/profile.png";
import tick from "../assets/tick.png";
import { Redirect } from "react-router-dom";
import profileTitle from "../assets/profileTitle.png";

const passRegex = new RegExp("^((?=.*[a-z])|(?=.*[A-Z]))(?=.*[0-9])");
export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fnameValue: "",
      lnameValue: "",
      emailValue: "",
      codeValue: "",
      mobileValue: "",
      imageurl: profileimage,
      imageUploaded: true,
      changePasswordPage: false,
      imageName: "",
      oldPasswordErrorText: "",
      passwordErrorText: "",
      repasswordErrorText: "",
      oldPasswordValue: "",
      passwordValue: "",
      repasswordValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      emailErrorText: "",
      Redirect: false,
      actionError: "",
      passwordNotSuccess: true,
      uploadButtonText: "انتخاب تصویر",
      uploadButtonDisable: false,
      backButtonDisabled: false,
      backButtonSpinner: false,
    };

    this.inputFile = React.createRef();

    this.uploadCatalog = this.uploadCatalog.bind(this);

    this.passwordHandleChange = this.passwordHandleChange.bind(this);
    this.repasswordHandleChange = this.repasswordHandleChange.bind(this);

    this.loginClick = this.loginClick.bind(this);
  }

  componentDidMount() {
    if (!this.props.inModal) this.props.onProfileLoad();
    this.setState({
      mobileValue: localStorage.getItem("mobile"),
      actionError: "",
    });

    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
    };

    fetch("/api/readPersonalInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.setState({
            fnameValue: result.result[0].first_name,
            lnameValue: result.result[0].last_name,
            emailValue: result.result[0].email,
          });
          if (
            result.result[0].profile_pic !== null &&
            result.result[0].profile_pic !== "broken.png"
          ) {
            this.setState({
              imageName: result.result[0].profile_pic,
              imageurl: "/api/public/" + result.result[0].profile_pic,
            });
          }
        } else if (result.status === 401) {
          this.setState({ Redirect: true });
        } else {
          this.setState({ actionError: "ارتباط با سرور برقرار نشد" });
        }
        this.setState({
          buttonText: true,
          buttonSpinner: false,
          buttonDisabled: false,
        });
      });
  }

  uploadCatalog(event) {
    this.setState({ actionError: "" });
    if (
      event.target.files[0] !== undefined &&
      (event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/jpeg")
    ) {
      const data = new FormData();
      data.append("file", event.target.files[0]);
      data.append("thumbnail", false);
      this.setState({
        uploadButtonText: "درحال بارگذاری ...",
        uploadButtonDisable: true,
      });
      axios.post("/api/uploadfile", data).then((res) => {
        if (res.data.status === 200) {
          this.setState({
            imageName: res.data.data.name,
            imageurl: "/api/public/" + res.data.data.name,
            imageUploaded: true,
          });
        } else {
          this.setState({ actionError: res.data.message });
          // this.setState({actionError:'در بارگذاری فایل مشکلی به وجود آمده است'})
          this.setState({
            imageurl: profileimage,
          });
        }
        this.setState({
          uploadButtonText: "انتخاب تصویر",
          uploadButtonDisable: false,
        });
      });
    }
  }

  nextClick(type) {
    this.setState({ actionError: "" });
    if (this.state.emailValue !== null && this.state.emailValue !== "") {
      if (!this.validateEmail(this.state.emailValue)) {
        this.refs.emailInput.setAttribute(
          "style",
          "border-color: var(--red1) !important"
        );
        this.setState({ emailErrorText: "ایمیل وارد شده نا معتبر است" });
        return;
      } else {
        this.refs.emailInput.setAttribute(
          "style",
          "border-color: #cfcfcf !important"
        );
        this.setState({ emailErrorText: "" });
      }
    } else {
      this.refs.emailInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ emailErrorText: "" });
    }

    let img = null;
    if (this.state.imageurl !== profileimage) {
      img = this.state.imageName;
    }

    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      first_name: this.state.fnameValue,
      last_name: this.state.lnameValue,
      email: this.state.emailValue,
      nid: null,
      profile_pic: img,
    };

    if (type === "back") {
      this.setState({ backButtonDisabled: true, backButtonSpinner: true });
    }

    fetch("/api/editPersonalInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          if (type === "back") {
            this.setState({ actionError: "" });
            this.props.onProfileBack();
          } else {
            this.props.onProfileNext();
          }
          return;
        } else if (result.status === 401) {
          this.setState({ Redirect: true });
        } else {
          this.setState({ actionError: "ارتباط با سرور برقرار نشد" });
        }
        if (type === "back") {
          this.setState({
            backButtonDisabled: false,
            backButtonSpinner: false,
          });
        }
      });
  }

  backClick() {
    this.nextClick("back");
  }

  fnameHandleChange(event) {
    this.setState({ fnameValue: event.target.value });
  }

  lnameHandleChange(event) {
    this.setState({ lnameValue: event.target.value });
  }

  emailHandleChange(event) {
    this.setState({ emailValue: event.target.value });
  }

  codeHandleChange(event) {
    this.setState({ codeValue: event.target.value });
  }

  openFileDialog() {
    this.inputFile.current.click();
  }

  saveProfile() {
    this.setState({ actionError: "" });
    if (this.state.emailValue !== null && this.state.emailValue !== "") {
      if (!this.validateEmail(this.state.emailValue)) {
        this.refs.emailInput.setAttribute(
          "style",
          "border-color: var(--red1) !important"
        );
        this.setState({ emailErrorText: "ایمیل وارد شده نا معتبر است" });
        return;
      } else {
        this.refs.emailInput.setAttribute(
          "style",
          "border-color: #cfcfcf !important"
        );
        this.setState({ emailErrorText: "" });
      }
    } else {
      this.refs.emailInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ emailErrorText: "" });
    }

    let img = null;

    // alert(this.state.imageurl)
    // alert(profileimage)
    if (this.state.imageurl !== profileimage) {
      img = this.state.imageName;
    }

    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      first_name: this.state.fnameValue,
      last_name: this.state.lnameValue,
      email: this.state.emailValue,
      nid: null,
      profile_pic: img,
    };

    this.setState({ buttonDisabled: true });

    fetch("/api/editPersonalInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.props.profileSave("/api/public/" + img);
        } else if (result.status === 401) {
          this.setState({ Redirect: true });
        } else {
          this.setState({ actionError: "ارتباط با سرور برقرار نشد" });
        }
        this.setState({ buttonDisabled: false });
      });
  }

  changePasswordClick() {
    this.setState({
      changePasswordPage: true,
      actionError: "",
      oldPasswordValue: "",
      passwordValue: "",
      repasswordValue: "",
    });
  }

  changePasswordBack() {
    this.setState({ changePasswordPage: false, actionError: "" });
  }

  loginClick = () => {
    this.setState({ actionError: "" });
    if (this.state.oldPasswordValue === "") {
      this.refs.oldPasswordInput.setAttribute(
        "style",
        "border-color: var(--red1) !important"
      );
      this.setState({
        oldPasswordErrorText: "لطفاً رمز عبور فعلی خود را وارد کنید",
      });
      return;
    } else {
      this.refs.oldPasswordInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ oldPasswordErrorText: "" });
    }

    if (this.state.passwordValue === "") {
      this.refs.newPasswordInput.setAttribute(
        "style",
        "border-color: var(--red1) !important"
      );
      this.setState({
        passwordErrorText: "لطفاً رمز عبور جدید خود را وارد کنید",
      });
      return;
    } else {
      this.refs.newPasswordInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ passwordErrorText: "" });
    }

    if (this.state.passwordValue.length >= 8) {
      this.refs.newPasswordInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ passwordErrorText: "" });
    } else {
      this.refs.newPasswordInput.setAttribute(
        "style",
        "border-color: var(--red1) !important"
      );
      this.setState({ passwordErrorText: "رمز عبور باید حداقل 8 رقم باشد" });
      return;
    }

    if (passRegex.test(this.state.passwordValue)) {
      this.refs.newPasswordInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ passwordErrorText: "" });
    } else {
      this.refs.newPasswordInput.setAttribute(
        "style",
        "border-color: var(--red1) !important"
      );
      this.setState({
        passwordErrorText: "رمز عبور باید ترکیبی از حروف انگلیسی و عدد باشد",
      });
      return;
    }

    if (this.state.repasswordValue === "") {
      this.refs.newRepasswordInput.setAttribute(
        "style",
        "border-color: var(--red1) !important"
      );
      this.setState({
        repasswordErrorText: "لطفاً رمز عبور جدید خود را تکرار کنید",
      });
      return;
    } else {
      this.refs.newRepasswordInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ repasswordErrorText: "" });
    }

    if (this.state.passwordValue === this.state.repasswordValue) {
      this.refs.newRepasswordInput.setAttribute(
        "style",
        "border-color: #cfcfcf !important"
      );
      this.setState({ repasswordErrorText: "" });
    } else {
      this.refs.newRepasswordInput.setAttribute(
        "style",
        "border-color: var(--red1) !important"
      );
      this.setState({
        repasswordErrorText: "رمز عبور های جدید با هم متفاوت است",
      });
      return;
    }

    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      cpassword: this.state.oldPasswordValue,
      npassword: this.state.repasswordValue,
    };

    this.setState({ buttonDisabled: true });
    fetch("/api/changePassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          // this.props.hideModal();
          this.setState({ passwordNotSuccess: false });
        } else if (result.status === 402) {
          this.setState({ actionError: "رمز عبور فعلی نادرست است" });
        } else if (result.status === 401) {
          this.setState({ Redirect: true });
        } else {
          this.setState({ actionError: "ارتباط با سرور برقرار نشد" });
        }
        this.setState({ buttonDisabled: false });
      });
  };

  oldPasswordHandleChange(event) {
    this.setState({ oldPasswordValue: event.target.value });
  }

  passwordHandleChange(event) {
    this.setState({ passwordValue: event.target.value });
  }

  repasswordHandleChange(event) {
    this.setState({ repasswordValue: event.target.value });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.loginClick();
    }
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    if (this.state.Redirect) return <Redirect to="/Login" />;
    if (!this.state.changePasswordPage) {
      return (
        <div
          style={
            this.props.inModal
              ? {
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  width: "100%",
                }
              : {
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  maxWidth: "450px",
                  width: "97%",
                  minHeight: "100vh",
                  height: "100vh",
                  maxHeight: "100vh",
                }
          }
        >
          {!this.props.inModal && (
            <div
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                display: "flex",
                padding: "0px",
                flexDirection: "column",
              }}
            >
              <img src={profileTitle} alt="logo" className="stepsLogo" />
              <div style={{ fontSize: "20px" }}>
                اطلاعات حساب کاربری خود را تکمیل کنید
              </div>
            </div>
          )}

          <div
            className={
              this.props.inModal
                ? "basketItemsContainer-modal"
                : "basketItemsContainer"
            }
          >
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "0px 15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="profilePicContainer">
                {this.state.imageUploaded && (
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src={this.state.imageurl}
                    alt="profile"
                  />
                )}
              </div>
              <input
                type="file"
                ref={this.inputFile}
                onChange={this.uploadCatalog}
                accept="image/png,.jpg"
                style={{ display: "none" }}
              />
              <Button
                onClick={this.openFileDialog.bind(this)}
                disabled={this.state.uploadButtonDisable}
                style={{
                  fontSize: "12px",
                  color: "white",
                  marginBottom: "25px",
                }}
              >
                {this.state.uploadButtonText}
              </Button>
              <Form.Control
                className="inputStyleProfile"
                placeholder="نام"
                type="text"
                name="fname"
                onChange={this.fnameHandleChange.bind(this)}
                value={this.state.fnameValue || ""}
                disabled={this.state.buttonDisabled}
              />

              <Form.Control
                className="inputStyleProfile"
                placeholder="نام خانوادگی"
                type="text"
                name="lname"
                onChange={this.lnameHandleChange.bind(this)}
                value={this.state.lnameValue || ""}
                disabled={this.state.buttonDisabled}
              />

              <Form.Control
                className="inputStyleProfile"
                placeholder="ایمیل"
                type="text"
                name="email"
                onChange={this.emailHandleChange.bind(this)}
                value={this.state.emailValue || ""}
                disabled={this.state.buttonDisabled}
                ref="emailInput"
              />
              <div className="errorMessage2">{this.state.emailErrorText}</div>

              <Form.Control
                className="inputStyleProfileDisabled"
                placeholder="لطفاً شماره تلفن همراه خود را وارد کنید"
                type="text"
                name="mobile"
                value={this.state.mobileValue || ""}
                disabled={true}
              />
            </div>
            {this.props.inModal && (
              <Button
                variant="secondary"
                disabled={this.state.uploadButtonDisable}
                style={{
                  fontSize: "14px",
                  margin: "15px 10px",
                  color: "white",
                  width: "62%",
                }}
                onClick={this.changePasswordClick.bind(this)}
              >
                تغییر رمز عبور
              </Button>
            )}
          </div>

          {this.state.actionError !== "" && (
            <div className="errorMessageContainer">
              <div>{this.state.actionError}</div>
            </div>
          )}

          {this.props.inModal && (
            <div className="popupButtons">
              {/* <Button variant="primary" style={{fontSize:'14px',margin:'5px'}} onClick={this.saveProfile.bind(this)}>ذخیره</Button> */}
              <Button
                variant="primary"
                style={{ fontSize: "14px", margin: "5px" }}
                disabled={
                  this.state.buttonDisabled || this.state.uploadButtonDisable
                }
                onClick={this.saveProfile.bind(this)}
              >
                {this.state.buttonDisabled && (
                  <Spinner className="spinnerStyle" animation="border" />
                )}
                {!this.state.buttonDisabled && <div>ذخیره</div>}
              </Button>
              <Button
                variant="danger"
                style={{ fontSize: "14px", margin: "5px" }}
                onClick={this.props.hideModal}
              >
                بستن
              </Button>
            </div>
          )}

          {!this.props.inModal && (
            <div style={{ width: "100%" }}>
              <div className="footerStyle">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "30px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      margin: "0px 7px",
                      backgroundColor: "var(--gray3)",
                      borderRadius: "50%",
                    }}
                  />
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      margin: "0px 7px",
                      backgroundColor: "var(--gray3)",
                      borderRadius: "50%",
                    }}
                  />
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      margin: "0px 7px",
                      backgroundColor: "var(--green1)",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "20px",
                    marginBottom: "30px",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Button
                    disabled={
                      this.state.uploadButtonDisable ||
                      this.state.backButtonDisabled
                    }
                    onClick={this.backClick.bind(this)}
                    style={{ minWidth: "150px", fontSize: "14px" }}
                  >
                    {this.state.backButtonSpinner && (
                      <Spinner className="spinnerStyle" animation="border" />
                    )}
                    {!this.state.backButtonSpinner && <div>بازگشت</div>}
                  </Button>
                  <Button
                    disabled={this.state.uploadButtonDisable}
                    onClick={this.nextClick.bind(this, "next")}
                    style={{ minWidth: "150px", fontSize: "14px" }}
                  >
                    ورود
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div
          style={{
            minWidth: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            direction: "rtl",
          }}
        >
          {this.state.passwordNotSuccess && (
            <div style={{ width: "100%" }}>
              <div className="password">
                <label htmlFor="password" style={{ fontSize: "12px" }}>
                  رمز عبور فعلی
                </label>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Form.Control
                    className="inputStyle"
                    placeholder="لطفاً رمز عبور فعلی خود را وارد کنید"
                    type="password"
                    onChange={this.oldPasswordHandleChange.bind(this)}
                    value={this.state.oldPasswordValue || ""}
                    disabled={this.state.buttonDisabled}
                    onKeyPress={this.handleKeyPress.bind(this)}
                    ref="oldPasswordInput"
                  />
                </div>
                <div className="errorMessage">
                  {this.state.oldPasswordErrorText}
                </div>
                <label
                  htmlFor="password"
                  style={{ marginTop: "10px", fontSize: "12px" }}
                >
                  رمز عبور جدید
                </label>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Form.Control
                    className="inputStyle"
                    placeholder="لطفاً رمز عبور جدید را وارد کنید"
                    type="password"
                    onChange={this.passwordHandleChange || ""}
                    value={this.state.passwordValue}
                    disabled={this.state.buttonDisabled}
                    onKeyPress={this.handleKeyPress.bind(this)}
                    ref="newPasswordInput"
                  />
                </div>
                <div className="errorMessage">
                  {this.state.passwordErrorText}
                </div>
                <label
                  htmlFor="password"
                  style={{ marginTop: "10px", fontSize: "12px" }}
                >
                  تکرار رمز عبور جدید
                </label>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Form.Control
                    className="inputStyle"
                    placeholder="لطفاً رمز عبور جدید را تکرار کنید"
                    type="password"
                    name="repassword"
                    id="repassword"
                    onChange={this.repasswordHandleChange}
                    value={this.state.repasswordValue || ""}
                    disabled={this.state.buttonDisabled}
                    onKeyPress={this.handleKeyPress.bind(this)}
                    ref="newRepasswordInput"
                  />
                </div>
                <div className="errorMessage">
                  {this.state.repasswordErrorText}
                </div>
              </div>

              <div className="popupButtons">
                <Button
                  variant="danger"
                  style={{ fontSize: "14px", margin: "5px" }}
                  onClick={this.changePasswordBack.bind(this)}
                >
                  بازگشت
                </Button>
                <Button
                  variant="primary"
                  style={{ fontSize: "14px", margin: "5px" }}
                  disabled={this.state.buttonDisabled}
                  onClick={this.loginClick}
                >
                  {this.state.buttonDisabled && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.buttonDisabled && <div>تایید</div>}
                </Button>
              </div>

              {this.state.actionError !== "" && (
                <div className="errorMessageContainer">
                  <div>{this.state.actionError}</div>
                </div>
              )}
            </div>
          )}

          {!this.state.passwordNotSuccess && (
            <div className="passwordSuccess">
              <img style={{ marginBottom: "15px" }} src={tick} alt="" />
              <div style={{ marginBottom: "20px" }}>
                رمز عبور با موفقیت تغییر کرد
              </div>
              <Button
                variant="primary"
                style={{ fontSize: "14px", margin: "5px" }}
                onClick={this.props.hideModal}
              >
                باشه
              </Button>
            </div>
          )}
        </div>
      );
    }
  }
}
